var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPpe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_ppe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_ppe",
    clipPath: "url(#clip-icon_ppe)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M20,12v-.9a7.955,7.955,0,0,0-4.093-6.964,1.061,1.061,0,0,0-.97-.635H13.722a1.983,1.983,0,0,0-3.444,0H9.062a1.057,1.057,0,0,0-.952.61A8,8,0,0,0,4,11.1V12H3v1H21V12ZM5,12v-.9A6.994,6.994,0,0,1,8,5.367V10.5H9l.062-6H10v5A2.5,2.5,0,0,1,7.5,12Zm4.942,0A3.485,3.485,0,0,0,11,9.5v-5a1,1,0,0,1,2,0v5A3.485,3.485,0,0,0,14.058,12ZM14,9.5V4.527l1,.036V10.5h1V5.352A6.963,6.963,0,0,1,19,11.1V12H16.5A2.5,2.5,0,0,1,14,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M18.725,14.987A3.01,3.01,0,0,0,16.5,14H7.643a3.194,3.194,0,0,0-2.711,1.5H3v3H4.9A2.987,2.987,0,0,0,7.5,20H9.882a1.491,1.491,0,0,0,1.342-.829L11.809,18h.382l.585,1.17a1.491,1.491,0,0,0,1.342.83h2.239a3.192,3.192,0,0,0,2.71-1.5H21v-3H19.1A2.993,2.993,0,0,0,18.725,14.987ZM4,17.5v-1h.554c-.011.065-.032.126-.039.192a3.031,3.031,0,0,0,.041.808ZM16.357,19H14.118a.5.5,0,0,1-.447-.276L12.809,17H11.191l-.862,1.724A.5.5,0,0,1,9.882,19H7.5a2,2,0,0,1-1.99-2.208A2.1,2.1,0,0,1,7.643,15H16.5a2,2,0,0,1,1.99,2.208A2.1,2.1,0,0,1,16.357,19ZM20,16.5v1h-.555c.011-.065.033-.126.039-.192a2.95,2.95,0,0,0-.041-.808Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 2.236,
    height: 1,
    transform: "translate(7.553 17.772) rotate(-63.435)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 2.236,
    height: 1,
    transform: "translate(14.553 17.772) rotate(-63.435)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPpe);
export default __webpack_public_path__ + "static/media/icon_ppe.c8fa201e40b8f971b9db5fcda8e8b048.svg";
export { ForwardRef as ReactComponent };